/*
 * Module for wrapping and initializing a signalr-based facadeviewer control
 */

rs.module("controls/diagnostics/facadeviewer-factory",

    ["ui/framework/client-templates"],

    function factory(clientTemplates) {

        var _instances = {};

        function getViewer(name) {

            if (!name) {
                name = 'single-instance';
            }

            var viewerInstance = _instances[name];

            if (!viewerInstance) {

                viewerInstance = (function () {
                    var _agGridApi = null;
                    var _columnIds = null;
                    var _signalRConnection = null;
                    var _url = null;
                    var _correlationId = null;
                    var _listenForUpdates = null;

                    // identifiers
                    var _allFilterJsSelector = null;
                    var _myFilterJsSelector = null;
                    var _actionLinksTemplateKey = null;
                    var _statusTemplateKey = null;

                    // connect to the SignalR hub and subscribe to new FacadeRecordingService events
                    function start() {

                        // if no url is defined, do not proceed.  This indicates the user doesn't have 
                        // permission, so there's no need in trying and getting SignalR errors.
                        if (_url == null) {
                            return;
                        }

                        // connect
                        _signalRConnection = new signalR.HubConnectionBuilder()
                            .withUrl(_url)
                            .withAutomaticReconnect()
                            .configureLogging(signalR.LogLevel.Error)
                            .build();

                        // start the SignalR connection
                        _signalRConnection.start().then(function () {

                            var allFilter = $.js(_allFilterJsSelector).is(':checked');
                            var retrieveMessages = (_listenForUpdates) ?
                                allFilter ? function () { return _signalRConnection.invoke("SubscribeToAll"); } :
                                    _correlationId ? function () { return _signalRConnection.invoke("SubscribeToCorrelated", _correlationId); } :
                                            function () { return _signalRConnection.invoke("SubscribeToMy"); }
                                : 
                                _correlationId ? function () { return _signalRConnection.invoke("GetCorrelatedRecordings", _correlationId); } :
                                                   function () { return _signalRConnection.invoke("GetAllRecordings"); };

                            // pull down the recordings
                            retrieveMessages().then(recordingsDownloaded).catch(err => console.error(err.toString()));

                        }).catch(err => console.error(err.toString()));

                        // handler for when a new recording was started on the server
                        _signalRConnection.on("RecordingAdded", function (recordingSummary) {

                            // Re-hydrate dates
                            recordingSummary.StartTime = new Date(recordingSummary.StartTime);

                            // Add the new row
                            _agGridApi.applyTransactionAsync({ add: [recordingSummary] })
                        });

                        // handler for when a recording has completed and has been analyzed
                        _signalRConnection.on("RecordingUpdated", function (recordingSummary) {
                            recordingSummary.StartTime = new Date(recordingSummary.StartTime);

                            _agGridApi.applyTransactionAsync({ update: [recordingSummary] });
                        });
                    }

                    // initialize the control
                    function initialize(
                        jsSelectors,
                        url,
                        connectImmediately,
                        listenForUpdates,
                        correlationId,
                        showFilter,
                        templateKeys,
                        tagContentAttribute,
                        lrsGridApi,
                        columnIds
                    ) {

                        var _control = $.js(jsSelectors.control);
                        _url = url;
                        _agGridApi = lrsGridApi.agGridApi;
                        _columnIds = columnIds;
                        _correlationId = correlationId;
                        _listenForUpdates = listenForUpdates;
                        _allFilterJsSelector = jsSelectors.allRequests;
                        _myFilterJsSelector = jsSelectors.myRequests;
                        _actionLinksTemplateKey = templateKeys.actionLinks;
                        _statusTemplateKey = templateKeys.statusBadges;

                        $.js(_allFilterJsSelector).on('change', requestFilterChanged);
                        $.js(_myFilterJsSelector).on('change', requestFilterChanged);

                        // clicking a badge copies the text to the clipboard
                        $(document).onjs("click", jsSelectors.badge, function (event) {
                            navigator.clipboard.writeText($(event.target).attr(tagContentAttribute));
                        });

                        // listen for check/uncheck of Ignore Retrieves
                        var ignoreRetrieves = $.js(jsSelectors.ignoreRetrieves);
                        ignoreRetrieves.on('change', function () {
                            if (ignoreRetrieves.prop("checked")) {
                                // apply the filter to ignore retrieves
                                setActionsFilter({ type: 'notContains', filter: 'retrieve' });
                            }
                            else {
                                // clear the filter
                                setActionsFilter(null);
                            }
                        });

                        // setup sort order
                        _agGridApi.applyColumnState({
                            state: [ { colId: _columnIds.startTime, sort: 'desc' } ]
                        });

                        if (!showFilter) {
                            _control.js(jsSelectors.filter).hide();
                        }

                        if (connectImmediately) {
                            start();
                        }

                    }

					// Set a filter on the Requests Actions column
					function setActionsFilter(value) {
                        _agGridApi.getColumnFilterInstance(_columnIds.messageActions).then(filter => {
                            filter.setModel(value);
                            _agGridApi.onFilterChanged();
                        });
					}

                    // An array of recordings were returned and need to be added to the user interface
                    function recordingsDownloaded(recordings) {
                        // Re-hydrate dates
                        recordings.forEach((recording) => {
                            recording.StartTime = new Date(recording.StartTime);
                        });

                        // save filters
                        var filterModel = _agGridApi.getFilterModel();

                        // replace the data
                        _agGridApi.updateGridOptions({ rowData: recordings });
                        
                        // restore the filters
                        _agGridApi.setFilterModel(filterModel);
                        _agGridApi.onFilterChanged();

                    }

                    // message filter changed, subscribe to different events
                    function requestFilterChanged() {
                        if ($(this).val() === "all") {
                            _signalRConnection.invoke("SubscribeToAll").then(recordingsDownloaded).catch(err => console.error(err));
                        }
                        else {
                            _signalRConnection.invoke("SubscribeToMy").then(recordingsDownloaded).catch(err => console.error(err));
                        }
                    }

                    // create action links cell
                    function renderActions(params) {
                        var recordingSummary = params.data;
                        var content = clientTemplates.render(_actionLinksTemplateKey,
                            {
                                recordingid: recordingSummary.RecordingId,
                                direction: "request",
                                getrecordingdata: true,
                                request: true
                            });

                        if (recordingSummary.Completed) {
                            content += clientTemplates.render(_actionLinksTemplateKey,
                                {
                                    recordingid: recordingSummary.RecordingId,
                                    direction: "response",
                                    getrecordingdata: true,
                                    response: true
                                });

                            content += clientTemplates.render(_actionLinksTemplateKey,
                                {
                                    recordingid: recordingSummary.RecordingId,
                                    generateentity: true
                                });
                        }

                        return content;
                    }

                    // render the Status column, called from the grid template column for status
                    function renderStatus(params) {
                        var recordingSummary = params.data;
                        var statusDetail = {};
                        var severityStyle = ["secondary", "info", "warning", "danger"];
                        if (recordingSummary.Completed) {
                            statusDetail.completed = true;
                            statusDetail.cached = recordingSummary.Cached;

                            // analysis badges
                            statusDetail.analysis = [];
                            statusDetail.recording = recordingSummary;
                            recordingSummary.AnalysisFlags.forEach(t => {
                                statusDetail.analysis.push({
                                    data: t.data,
                                    identifier: t.identifier,
                                    severity: severityStyle[t.severity]
                                });
                            });
                        }

                        var content = clientTemplates.render(_statusTemplateKey, statusDetail);
                        return content;
                    }

                    // the interface to the control
                    var viewerExports = {
                        initialize: initialize,
                        renderStatus: renderStatus,
                        renderActions: renderActions,
                        start: start
                    };

                    return viewerExports;
                })();

                _instances[name] = viewerInstance;
            }

            return viewerInstance;
        }

        // getRowId grid callback for assigning a row id, letting us quickly update records 
        // for which we're notified of changes. 
        function getRowId(params) {
            return params.data.RecordingId;
        };

        /// the interface to the control
        var exports = {
            getViewer: getViewer,
            getRowId: getRowId
        };

        return exports;
    }
);
